import { LoaderScreen } from '@/components/Elements';
import { ArticleDetailContent } from '@/features/article-detail/components/ArticleDetailContent';
import { ArticleDetailLayout } from '@/features/article-detail/components/ArticleDetailLayout';
import { graphql, useQuery } from '@/lib/graphql';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

const GET_ARTICLE_DETAIL_QUERY = graphql(
  `
    query getArticleDetail($code: String!) {
      article(code: $code) {
        ...ArticleDetailContentFragment
      }
    }
  `,
  [ArticleDetailContent.fragments.data]
);

export const ArticleDetail = () => {
  const { t } = useTranslation();
  const { code } = useParams();

  const { data, loading } = useQuery(GET_ARTICLE_DETAIL_QUERY, {
    variables: { code: code ?? '' },
    skip: !code,
  });

  return (
    <ArticleDetailLayout>
      {loading ? (
        <div className="flex min-h-[45vh] w-full items-center justify-center">
          <LoaderScreen />
        </div>
      ) : !data?.article ? (
        <div className="rounded-md bg-white p-6 text-sm text-rw-sub">
          {t('記事が見つかりませんでした。')}
        </div>
      ) : (
        <ArticleDetailContent article={data.article} />
      )}
    </ArticleDetailLayout>
  );
};
